export const LOGIN_NOTIFICATION_ENABLED = true;
export const SHOW_LOGIN_NOTIFICATION_KEY = 'showLoginNotification';

/** Popup is shown through 31.10.2026 23:59 Europe/Berlin and hidden from 01.11.2026 00:00. */
export const LOGIN_NOTIFICATION_EXPIRES_AT_BERLIN = '2026-11-01 00:00:00';
export const LOGIN_NOTIFICATION_TIME_ZONE = 'Europe/Berlin';

export interface NotificationDialogContent {
  title: string;
  closeButtonText: string;
  intro: string[];
  previousAddressLabel: string;
  previousAddressUrl: string;
  newAddressLabel: string;
  newAddressUrl: string;
  accessUnchanged: string;
  secondary: string[];
}

export function isLoginNotificationActive(now: Date = new Date()): boolean {
  if (!LOGIN_NOTIFICATION_ENABLED) {
    return false;
  }

  const berlinNow = now.toLocaleString('sv-SE', { timeZone: LOGIN_NOTIFICATION_TIME_ZONE });
  return berlinNow < LOGIN_NOTIFICATION_EXPIRES_AT_BERLIN;
}

export const LOGIN_NOTIFICATION_CONTENT: Record<'en' | 'de', NotificationDialogContent> = {
  en: {
    title: 'Update: New Address of Operate',
    closeButtonText: 'OK',
    intro: [
      'We would like to inform you that the address of Operate is changing.',
      'As part of our new corporate identity as Lexit Group Germany, Operate will be available at a new address:',
    ],
    previousAddressLabel: 'Previous address',
    previousAddressUrl: 'https://operate.circlon.net',
    newAddressLabel: 'New address',
    newAddressUrl: 'https://operate.lexitcloud.com',
    accessUnchanged:
      'Your access details will of course remain unchanged, and all functionalities you are familiar with will still be available.',
    secondary: [
      'To make sure you can continue to reach Operate quickly, we recommend saving the new address as a bookmark in your browser. Simply open the new address first and then proceed as follows:',
      'Google Chrome: Click the star icon in the address bar and confirm with "Done".',
      'Mozilla Firefox: Click the star icon in the address bar and confirm with "Save".',
      'Microsoft Edge: Click the star icon in the address bar and confirm with "Done".',
      'Alternatively, you can use the keyboard shortcut Ctrl + D (Windows) or Cmd + D (Mac) in all three browsers. You are then welcome to remove your previous bookmark.',
      "If you have any questions or feedback, please don't hesitate to contact us.",
      'Thank you for your continued trust.',
    ],
  },
  de: {
    title: 'Update: Neue Adresse von Operate',
    closeButtonText: 'OK',
    intro: [
      'Wir möchten Sie darüber informieren, dass sich die Adresse von Operate ändert.',
      'Im Zuge unserer neuen Corporate Identity als Lexit Group Germany erreichen Sie Operate künftig unter einer neuen Adresse:',
    ],
    previousAddressLabel: 'Bisherige Adresse',
    previousAddressUrl: 'https://operate.circlon.net',
    newAddressLabel: 'Neue Adresse',
    newAddressUrl: 'https://operate.lexitcloud.com',
    accessUnchanged:
      'Ihre Zugangsdaten bleiben selbstverständlich unverändert, und alle Ihnen bekannten Funktionen stehen Ihnen weiterhin zur Verfügung.',
    secondary: [
      'Damit Sie Operate auch künftig schnell erreichen, empfehlen wir Ihnen, die neue Adresse als Lesezeichen in Ihrem Browser zu speichern. Öffnen Sie dazu zunächst die neue Adresse und gehen Sie dann wie folgt vor:',
      'Google Chrome: Klicken Sie auf das Stern-Symbol in der Adressleiste und bestätigen Sie mit „Fertig".',
      'Mozilla Firefox: Klicken Sie auf das Stern-Symbol in der Adressleiste und bestätigen Sie mit „Speichern".',
      'Microsoft Edge: Klicken Sie auf das Stern-Symbol in der Adressleiste und bestätigen Sie mit „Fertig".',
      'Alternativ können Sie in allen drei Browsern die Tastenkombination Strg + D (Windows) bzw. Cmd + D(Mac) verwenden. Ihr bisheriges Lesezeichen können Sie anschließend gerne entfernen.',
      'Bei Fragen oder Feedback können Sie sich jederzeit gerne an uns wenden.',
      'Vielen Dank für Ihr fortwährendes Vertrauen.',
    ],
  },
};
